const HeroSection = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_e4b3f34f6b44ec2569d250e332708bd4_80e0ebfe.jpg"
          alt="Skincare distribuidores autorizados Costa Rica"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 py-32 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-block px-5 py-2 border border-white/50 rounded-full mb-8">
            <span className="text-white/90 text-sm font-light tracking-wider">Distribuidores Autorizados en Costa Rica</span>
          </div>
          <h1 className="font-['Playfair_Display'] text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Skincare de Calidad<br />Directo a Tu Piel
          </h1>
          <p className="text-xl lg:text-2xl text-white/85 font-light mb-12 leading-relaxed max-w-2xl mx-auto">
            Somos distribuidores autorizados de los mejores productos de cuidado de la piel en Costa Rica. Marcas internacionales certificadas, especialmente <strong className="font-semibold text-white">La Roche-Posay</strong>.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
            <button
              onClick={() => scrollToSection('productos')}
              className="group px-8 py-4 bg-white/95 text-gray-900 text-base font-medium rounded-full hover:bg-white transition-all flex items-center space-x-3 whitespace-nowrap cursor-pointer"
            >
              <span>Ver Productos</span>
              <div className="w-8 h-8 flex items-center justify-center bg-gray-900 rounded-full group-hover:bg-gray-800 transition-colors">
                <i className="ri-arrow-right-line text-white text-sm"></i>
              </div>
            </button>
            <button
              onClick={() => scrollToSection('distribucion')}
              className="px-8 py-4 border border-white/70 text-white text-base font-light rounded-full hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              Venta al Por Mayor
            </button>
          </div>
        </div>

        <div className="absolute bottom-12 right-12 hidden lg:flex flex-col gap-3">
          <div className="w-24 h-24 bg-white/95 rounded-full flex items-center justify-center shadow-lg">
            <div className="text-center">
              <i className="ri-verified-badge-line text-[#D4AF37] text-2xl mb-1"></i>
              <p className="text-xs font-semibold text-gray-900">Testado</p>
              <p className="text-xs text-gray-600">Clínicamente</p>
            </div>
          </div>
          <div className="w-24 h-24 bg-white/95 rounded-full flex items-center justify-center shadow-lg">
            <div className="text-center">
              <i className="ri-truck-line text-[#D4AF37] text-2xl mb-1"></i>
              <p className="text-xs font-semibold text-gray-900">Envíos</p>
              <p className="text-xs text-gray-600">Costa Rica</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
